import script from "./DynamicReport.vue?vue&type=script&setup=true&lang=js"
export * from "./DynamicReport.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__

/* vue-cli-plugin-import-components */

import ReportChart from "@/components/reports/ReportChart.vue";
script.components = Object.assign({}, { ReportChart }, script.components);if ('__vccOpts' in script) { script.__o = script.__o || {}; script.__o.components = Object.assign({}, { ReportChart }, script.__o.components);}